import React from 'react';
import PropTypes from 'prop-types';

const PercentageField = ({ label, source, record = {} }) => [<span>{label}</span>, <span>{Math.round(record[source] * 100.0)} %</span>];

PercentageField.propTypes = {
  label: PropTypes.string,
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

PercentageField.defaultProps = {
  addLabel: true,
};

export default PercentageField;
